import BentoCapabilities from "@/components/BentoCapabilities";
import BrandsMarquee from "@/components/BrandsMarquee";
import CampaignHeading from "@/components/CampaignHeading";
import CtaBanner from "@/components/CtaBanner";
import FaqSection from "@/components/FaqSection";
import FashionHero from "@/components/FashionHero";
import FeaturesSection from "@/components/FeaturesSection";
import Footer from "@/components/Footer";

import Navbar from "@/components/Navbar";
import OneImageShowcase, {
    ecommerceTools,
} from "@/components/OneImageShowcase";
import PageSEO from "@/components/PageSEO";
import PinkCtaBanner from "@/components/PinkCtaBanner";
import SocialProof from "@/components/SocialProof";
import ecommerceMd from "@/content/faqs/ecommerce.md?raw";
import { parseFaqs } from "@/lib/faqs";
import { buildFaqJsonLd } from "@/lib/seo";

const ecommerceFaqs = parseFaqs(ecommerceMd);

const ecommerceHeroVideos = [
    { src: "https://cdn.pixro.ai/6cec104d-7ba5-4796-9c12-5998711e78fd.mp4", alt: "Ecommerce product video 1" },
    { src: "https://cdn.pixro.ai/52a283ce-07da-4cc1-93aa-cc0e58a42ff8.mp4", alt: "Ecommerce product video 2" },
    { src: "https://cdn.pixro.ai/9ced01e1-6a43-4374-9b10-22ed1ac80b55.mp4", alt: "Ecommerce product video 3" },
    { src: "https://cdn.pixro.ai/97cbfda1-af3c-4b3d-a371-0a3c8223da01.mp4", alt: "Ecommerce product video 4" },
    { src: "https://cdn.pixro.ai/bf59dc5f-d10a-4a19-add1-808d657ed43b.mp4", alt: "Ecommerce product video 5" },
    { src: "https://cdn.pixro.ai/52ce4f94-89d1-44b0-8ef8-50b86466c58a.mp4", alt: "Ecommerce product video 6" },
    { src: "https://cdn.pixro.ai/4dd49de2-1e51-4382-a1fe-f0361ffe4305.mp4", alt: "Ecommerce product video 7" },
];

const Ecommerce = () => {
    return (
        <div className="min-h-screen bg-background">
            <PageSEO
                title="AI Product Visuals for Ecommerce Stores | Pixro AI"
                description="Create high-converting product photos, lifestyle scenes, and shoppable videos for your ecommerce catalog at scale with AI visual content for D2C brands."
                path="/solutions/ecommerce"
                jsonLd={buildFaqJsonLd(ecommerceFaqs)}
            />
            <Navbar />
            <FashionHero
                eyebrowAccent="conversion - driven"
                eyebrowSuffix="storefront"
                headlineBold="AI ecommerce"
                headlineRest="for catalogs that scale"
                description="Generate scroll-stopping product imagery and on-brand visuals for every SKU, at the speed your catalog demands."
                videos={ecommerceHeroVideos}
            />
            <FeaturesSection
                heading="Your end-to-end platform for ecommerce-ready AI visuals."
                subheading="Create high-converting product shots, lifestyle scenes, and shoppable videos with AI, built for fast-moving catalogs."
            />
            <BrandsMarquee />
            <div className="bg-background">
                <SocialProof
                    heading="Trusted by 5000+ ecommerce brands worldwide"
                    description="Pixro.AI Ecommerce is an all-in-one visual content platform for online retailers and DTC brands, uniting product photography, lifestyle scenes, and ad creative in a single workflow."
                />
            </div>
            <OneImageShowcase
                heading="Everything you can do with one product image"
                description="Lifestyle scenes, background swaps, on-model shots, video generation, flat lays, and ad creatives. Pixro.AI turns one product photo into a complete ecommerce campaign."
                tools={ecommerceTools}
            />
            <CtaBanner heading="Join thousands of ecommerce sellers. Start your free trial" />
            <CampaignHeading
                domain="ecommerce"
                description="From product upload to ready-to-publish ads, Pixro replaces every step of your traditional ecommerce content workflow."
            />
            <BentoCapabilities domain="ecommerce" />
            <PinkCtaBanner heading="Launch product pages and ads in seconds, with studio polish on every SKU" />
            <FaqSection faqs={ecommerceFaqs} />
            <Footer />
        </div>
    );
};

export default Ecommerce;
